export const getVariantOptionsNamespace = (namespace: string) => `${namespace}_options`;
